import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_tooltip = _resolveComponent("tooltip")

  return (_openBlock(), _createBlock(_resolveDynamicComponent($props.tag), null, {
    default: _withCtx(() => [
      (_ctx.convertedDisplayCurrency)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            ($props.reverseTooltipPosition)
              ? _renderSlot(_ctx.$slots, "tooltip", {}, () => [
                  ($props.displayTooltip)
                    ? (_openBlock(), _createBlock(_component_tooltip, {
                        key: 0,
                        class: "_flexinline _ai-c"
                      }, {
                        content: _withCtx(() => [
                          _renderSlot(_ctx.$slots, "tooltip-content")
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_base_icon, {
                            name: "sync",
                            class: _normalizeClass($options.computedIconClasses),
                            "has-base-class": ""
                          }, null, 8 /* PROPS */, ["class"])
                        ]),
                        _: 3 /* FORWARDED */
                      }))
                    : _createCommentVNode("v-if", true)
                ], undefined, 0)
              : _createCommentVNode("v-if", true),
            _renderSlot(_ctx.$slots, "content", { displayCurrency: _ctx.convertedDisplayCurrency }),
            (!$props.reverseTooltipPosition)
              ? _renderSlot(_ctx.$slots, "tooltip", {}, () => [
                  ($props.displayTooltip)
                    ? (_openBlock(), _createBlock(_component_tooltip, {
                        key: 0,
                        class: "_flexinline _ai-c"
                      }, {
                        content: _withCtx(() => [
                          _renderSlot(_ctx.$slots, "tooltip-content")
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_base_icon, {
                            name: "sync",
                            class: _normalizeClass($options.computedIconClasses),
                            "has-base-class": ""
                          }, null, 8 /* PROPS */, ["class"])
                        ]),
                        _: 3 /* FORWARDED */
                      }))
                    : _createCommentVNode("v-if", true)
                ], undefined, 1)
              : _createCommentVNode("v-if", true),
            _renderSlot(_ctx.$slots, "content-alt", { displayCurrency: _ctx.convertedDisplayCurrency })
          ], 64 /* STABLE_FRAGMENT */))
        : _renderSlot(_ctx.$slots, "default", {}, undefined, undefined, 1)
    ]),
    _: 3 /* FORWARDED */
  }))
}